import * as TK from 'components/search/PostsTab/translations/constants';
import { Translations } from 'translations/types';

export const postsTabEnUsLocale: Translations = {
  [TK.POSTS_TAB_LOADING_MORE]: 'Loading more posts',
};
